import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Callback = () => {
    const navigate = useNavigate();

    useEffect(() => {
        console.log("Callback: Component mounted");
        const hash = window.location.hash;
        const search = window.location.search; // Handle query params for Code flow (Consent)
        console.log("Callback: Hash:", hash, "Search:", search);

        // Handle Consent Grant (Authorization Code flow)
        if (search) {
            const params = new URLSearchParams(search);
            const code = params.get('code');
            if (code) {
                document.body.innerHTML = `
                    <div style="padding: 20px; text-align: center; font-family: sans-serif;">
                        <h1 style="color: green;">Consent Granted!</h1>
                        <p>You have successfully authorized the application.</p>
                        <p>You can now close this window and <b>retry sending the contract</b> in the main tab.</p>
                        <button onclick="window.close()" style="padding: 10px 20px; cursor: pointer;">Close Window</button>
                    </div>
                `;
                return;
            }
        }

        if (hash) {
            const params = new URLSearchParams(hash.substring(1)); // remove #
            const accessToken = params.get('access_token');
            const error = params.get('error');
            const errorDesc = params.get('error_description');

            console.log("Callback: Token found:", !!accessToken);
            if (error) {
                console.error("Callback: Error from DocuSign:", error, errorDesc);
                document.body.innerHTML = `<h1>Error: ${error}</h1><p>${errorDesc}</p>`;
                return;
            }
            
            if (accessToken) {
                // Determine if we are in a popup
                if (window.opener) {
                    console.log("Callback: Posting message to opener");
                    window.opener.postMessage({ type: 'DOCUSIGN_TOKEN', token: accessToken }, window.location.origin);
                    console.log("Callback: Closing window");
                    window.close();
                } else {
                    console.log("Callback: No opener (redirect mode), saving to storage");
                    // Fallback if not in popup (redirect mode)
                    localStorage.setItem('docusign_access_token', accessToken);
                    localStorage.setItem('docusign_token_expiry', Date.now() + 3600 * 1000);
                    navigate('/dashboard'); // or wherever
                }
            }
        } else {
            console.log("Callback: No hash found");
        }
    }, [navigate]);

    return (
        <div style={{ padding: 20 }}>
            <h1>Processing DocuSign Login...</h1>
            <p>Please wait. Do not close this window manually.</p>
        </div>
    );
};

export default Callback;
